/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Return_NativeInputs */

const en_mcp_connect_return_native = /** @type {(inputs: Mcp_Connect_Return_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`After you choose, you’ll return to ${i?.app} in an app on this device`)
};

const es_mcp_connect_return_native = /** @type {(inputs: Mcp_Connect_Return_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Después de elegir, volverás a ${i?.app} en una app de este dispositivo`)
};

/**
* | output |
* | --- |
* | "After you choose, you’ll return to {app} in an app on this device" |
*
* @param {Mcp_Connect_Return_NativeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_return_native = /** @type {((inputs: Mcp_Connect_Return_NativeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Return_NativeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_return_native(inputs)
	return en_mcp_connect_return_native(inputs)
});